import { render, staticRenderFns } from "./RatingScaleDrawer.vue?vue&type=template&id=5f1427f7"
import script from "./RatingScaleDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./RatingScaleDrawer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports